import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Calendar, Sparkles, Tent } from 'lucide-react';
import AdminSectionsPage from './AdminSectionsPage';
import AdminWorkshopsPage from './AdminWorkshopsPage';
import AdminCampsScheduleView from './AdminCampsScheduleView';

export default function AdminSchedulingPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'courses';

  const setTab = (value) => {
    setSearchParams({ tab: value });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Scheduling</h1>
        <p className="text-muted-foreground">Manage courses, workshops, and summer camps</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="courses" className="flex items-center gap-2" data-testid="tab-courses">
            <Calendar className="h-4 w-4" />
            Courses
          </TabsTrigger>
          <TabsTrigger value="workshops" className="flex items-center gap-2" data-testid="tab-workshops">
            <Sparkles className="h-4 w-4" />
            Workshops
          </TabsTrigger>
          <TabsTrigger value="camps" className="flex items-center gap-2" data-testid="tab-camps">
            <Tent className="h-4 w-4" />
            Summer Camps
          </TabsTrigger>
        </TabsList>

        <TabsContent value="courses">
          <AdminSectionsPage embedded />
        </TabsContent>
        <TabsContent value="workshops">
          <AdminWorkshopsPage embedded />
        </TabsContent>
        <TabsContent value="camps">
          <AdminCampsScheduleView />
        </TabsContent>
      </Tabs>
    </div>
  );
}
